import { getAPIUrl } from '../global';
import { Get, Post, Put, Remove } from '../headerIntercepter';

export const userCreate = (data,params) => {
  const url = getAPIUrl('organization.userCreate',params);
  return Post(url, data, true);
};
export const getUser = (params) => {
  const url = getAPIUrl('organization.users',params);
  return Get(url, true, {});
};